import { render, staticRenderFns } from "./AdminApprovedInvoices.vue?vue&type=template&id=f2aefedc&"
import script from "./AdminApprovedInvoices.vue?vue&type=script&lang=js&"
export * from "./AdminApprovedInvoices.vue?vue&type=script&lang=js&"
import style0 from "./AdminApprovedInvoices.vue?vue&type=style&index=0&id=f2aefedc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCard,VChip,VDataTable,VDivider,VSimpleCheckbox})
